import {
    EmailShareButton,
    EmailIcon,
} from 'next-share';

export const EmailShareTemplate = ({ pageUrl, pageTitle, body }) => {
    return (
        <EmailShareButton url={pageUrl} subject={pageTitle} body={body}>
            <EmailIcon size={44} round />
        </EmailShareButton>
    );
}